
export type Option = {
  label: string
  value: string | number
  item?: any
}

export const getLableByValue = (value: string | number, options: Option[]) => {
  if(!Array.isArray(options)) {
    return
  }
  const option = options.find(item => item.value === value)
  if(!option) {
    return ''
  }
  return option.label
}

export const gztLyOptions = [
  { label: '项目', value: '项目' },
  { label: '非项目', value: '非项目' },
]

export const jeOptions = [
  { value: '0', label: '全部' },
  { value: '1', label: '0-50万元', filter: (data) => data < 50 && data >= 0 },
  { value: '2', label: '0-100万元', filter: (data) => data < 100 && data >= 0 },
  { value: '3', label: '100万元-500万元', filter: (data) => data < 500 && data >= 100 },
  { value: '4', label: '100万元以上', filter: (data) => data >= 100 },
  { value: '5', label: '500万元以上', filter: (data) => data >= 500 },
]
